export function getAdminRedirectPath(adminData) {
  const role = adminData?.role || 'unknown';

  if (role === 'superadmin') return '/admin/super';
  if (role === 'field_operator') return '/operator';
  if (role === 'regionLead' || role === 'region-lead') return '/admin/region-lead';
  if (role === 'mason' || role === 'admin') return '/admin/bookings';
  return '/admin/bookings';
}

export function isRegionSuspended(adminData) {
  return adminData?.regionStatus === 'suspended';
}
